<template>
  <form
    class="form"
    :class="props.horizontal ? 'form--horizontal' : 'form--vertical'"
    novalidate
    @submit="submit"
  >
    <slot/>
  </form>
</template>

<script setup>
  import { provide, computed } from 'vue';

  const emit = defineEmits(['submit']);

  const props = defineProps({
    errors: {
      type: Object,
      default: null,
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
  });

  const formOptions = computed(() => {
    const obj = {
      formOptions: {
        fieldErrors: props.errors,
      },
    };

    Object.defineProperty(obj.formOptions, 'fieldLayoutHorizontal', {
      enumerable: true,
      get: () => props.horizontal,
    });

    return obj;
  });

  provide('formOptions', formOptions.value);

  function submit(event) {
    event.preventDefault();
    emit('submit');
  }
</script>
